import { Navigate, Outlet, useLocation, useRoutes } from 'react-router-dom'
// layouts
import DashboardLayout                              from './layouts/dashboard'
import UserPage                                     from './ui/user/UserPage'
import NotFound                                     from './ui/NotFoundPage.js'
import SignInPage                                   from './ui/user/SignInPage'
import React, { useContext }                        from 'react'
import UsersPage                                    from './ui/user/UsersPage'
import { AppContext }                               from './App'
import ForbiddenPage                                from './ui/ForbiddenPage'
import ServicePage                                  from './ui/service/ServicePage'
import ServicesPage                                 from './ui/service/ServicesPage'
import SharePage                                    from './ui/service/SharePage'
import MessagesPage                                 from './ui/message/MessagesPage'
import MessagePage                                  from './ui/message/MessagePage'
import MessageStatisticsPage                        from './ui/message/MessageStatisticsPage'
import PartnerPage                                  from './ui/partner/PartnerPage'
import PartnersPage                                 from './ui/partner/PartnersPage'
import Providers                                    from './ui/provider/Providers'
import ProviderPage                                 from './ui/provider/ProviderPage'
import BlacklistPage                                from './ui/listed/BlacklistPage'
import CategoriesPage                               from './ui/category/CategoriesPage'
import CategoryPage                                 from './ui/category/CategoryPage'
import ErrorsPage                                   from './ui/ErrorsPage'
import WhitelistPage                                from './ui/listed/WhitelistPage'
import WhitelistItemPage                            from './ui/listed/WhitelistItemPage'
import BlackListItemPage                            from './ui/listed/BlacklistItemPage'
import SearchPage                                   from './ui/SearchPage'
import SmsBroadcastPage                             from './ui/broadcast/SmsBroadcastPage'
import SharesStatisticsPage                         from './ui/share/SharesStatisticsPage'
import { User }                                     from './consts'

// ----------------------------------------------------------------------

const ProtectedRoute = ({ allowedUserTypes, children }) => {

  const location = useLocation()
  const { user } = useContext(AppContext)

  if (user === null) {
    return <Navigate to="/sign-in" state={{ from: location }}/>
  }

  if (!!allowedUserTypes && allowedUserTypes.indexOf(user.type) === -1){
    return <Navigate to={'/'} />
  }

  return (<React.Fragment>{children}</React.Fragment>)
}

const AdminProtectedRoute = ({ children }) => {
  return <ProtectedRoute allowedUserTypes={[User.typeAdmin]}>
    {children}
  </ProtectedRoute>
}

export default function Router () {

  return useRoutes([
    {
      path: '/dashboard',
      element: <ProtectedRoute><DashboardLayout/></ProtectedRoute>,
      children: [
        { path: 'services', children: [
            { path: ':serviceId/share/:shareId', element: <AdminProtectedRoute><SharePage /></AdminProtectedRoute> },
            { path: ':serviceId', element: <AdminProtectedRoute><ServicePage /></AdminProtectedRoute> },
            { path: '', element: <ProtectedRoute><ServicesPage /></ProtectedRoute> },
          ]
        },
        { path: 'users/:userId', element: <AdminProtectedRoute><UserPage /></AdminProtectedRoute> },
        { path: 'users', element: <AdminProtectedRoute><UsersPage /></AdminProtectedRoute> },
        { path: 'messages/:messageId', element: <ProtectedRoute><MessagePage /></ProtectedRoute> },
        { path: 'messages', element: <ProtectedRoute><MessagesPage /></ProtectedRoute> },
        { path: 'statistics/messages/', children: [
            { path: ':from/:to/:groupBy/:serviceIds', element: <ProtectedRoute><MessageStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to/:groupBy', element: <ProtectedRoute><MessageStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to', element: <ProtectedRoute><MessageStatisticsPage /></ProtectedRoute> },
            { path: '', element: <ProtectedRoute><MessageStatisticsPage /></ProtectedRoute> },
          ]
        },
        { path: 'statistics/shares/', children: [
            { path: ':from/:to/:groupBy/:serviceIds', element: <ProtectedRoute><SharesStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to/:groupBy', element: <ProtectedRoute><SharesStatisticsPage /></ProtectedRoute> },
            { path: ':from/:to', element: <ProtectedRoute><SharesStatisticsPage /></ProtectedRoute> },
            { path: '', element: <ProtectedRoute><SharesStatisticsPage /></ProtectedRoute> },
          ]
        },
        { path: 'partners/:partnerId', element: <AdminProtectedRoute><PartnerPage /></AdminProtectedRoute> },
        { path: 'partners', element: <AdminProtectedRoute><PartnersPage /></AdminProtectedRoute> },
        { path: 'providers/:providerId', element: <AdminProtectedRoute><ProviderPage /></AdminProtectedRoute> },
        { path: 'providers', element: <AdminProtectedRoute><Providers /></AdminProtectedRoute> },
        { path: 'blacklist/add', element: <AdminProtectedRoute><BlackListItemPage /></AdminProtectedRoute> },
        { path: 'blacklist/:blacklistItemId', element: <AdminProtectedRoute><BlackListItemPage /></AdminProtectedRoute> },
        { path: 'blacklist', element: <AdminProtectedRoute><BlacklistPage /></AdminProtectedRoute> },
        { path: 'whitelist/add', element: <AdminProtectedRoute><WhitelistItemPage /></AdminProtectedRoute> },
        { path: 'whitelist/:whitelistItemId', element: <AdminProtectedRoute><WhitelistItemPage /></AdminProtectedRoute> },
        { path: 'whitelist', element: <AdminProtectedRoute><WhitelistPage /></AdminProtectedRoute> },
        { path: 'categories', element: <AdminProtectedRoute><CategoriesPage /></AdminProtectedRoute> },
        { path: 'category/:categoryId', element: <AdminProtectedRoute><CategoryPage /></AdminProtectedRoute> },
        { path: 'search/:telNumber', element: <ProtectedRoute><SearchPage /></ProtectedRoute> },
        { path: 'errors', element: <AdminProtectedRoute><ErrorsPage /></AdminProtectedRoute> },
        { path: 'sms-broadcast', element: <AdminProtectedRoute><SmsBroadcastPage/></AdminProtectedRoute> },
        { path: '404', element: <NotFound/> },
        { path: 'forbidden', element: <ForbiddenPage/> },
        { path: '*', element: <Navigate to="/dashboard/404" replace={true} /> },
      ],
    },
    {
      path: '/',
      element: <Outlet />,
      children: [
        { path: '/sign-in', element: <SignInPage/> },
        { path: '*', element: <Navigate to="/dashboard/404" replace={true} /> },
      ],
    },
    { index: true, element: <Navigate to="/dashboard/services" replace={true} /> },
  ])
}
